import React from "react";
import {
  Avatar,
  AvatarGroup,
  Box,
  Text,
  Flex,
  InputGroup,
  InputRightElement,
  Input,
  Stack
} from "@chakra-ui/core";
import Logo from '../elements/Logo'
import { GoPrimitiveDot } from 'react-icons/go';
import { IoIosArrowBack, IoIosSend } from 'react-icons/io';
import { FaRegImage } from "react-icons/fa";
import { MdInsertEmoticon } from 'react-icons/md'

/** The phone mockup rendered on the Landing page
 * Will need to be refactored later for more dry code and reusability
 */

function PhoneMockup() {
  return (
      <Box
      borderWidth="12px"
      m="auto"
      maxW="340px"
      borderRadius="40px"
      bg="#FFFFFF"
      borderColor="#fbfbfb"
      style={{boxShadow: "2px 11px 45px -9px rgba(0,0,0,0.5)", WebkitTransform: "translateZ(-1000px) perspective(2000px) rotateY(-15deg) rotateX(10deg)"}}
      >
        <Stack 
        isInline
        spacing={0}
        >
          <Box 
            w="25%"         
            bg="#fbfbfb"
            borderTopLeftRadius="40px"
            >
              <Box 
                w="100%" 
                h="100%"
                background="#FFFFFF"
                borderTopRightRadius="18px"
                borderTopLeftRadius="40px"
              >
              </Box>
          </Box>
          <Stack
          w="50%"
          isInline
          alignItems="center"
          justifyContent="center"
          py="8px"
          px="6px"
          bg="#fbfbfb"
          borderBottomLeftRadius="10px"
          borderBottomRightRadius="10px"
          >
            <Box 
              h="8px"
              width="60%"
              minW="60px"
              borderRadius="20px" 
              bg="primary.300"
            >                    
            </Box>
            <Box color="primary.300" as={GoPrimitiveDot} />
          </Stack>
          <Box 
            w="25%"         
            bg="#fbfbfb"
            borderTopRightRadius="40px"
            >
              <Box 
                w="100%" 
                h="100%"
                background="#FFFFFF"
                borderTopLeftRadius="18px"
                borderTopRightRadius="40px"
              >
              </Box>
          </Box>

        </Stack>
        {/* Phone Header section*/}
        <Stack borderBottom="1px" borderBottomColor="primary.200" w="85%" m="auto" pt="15px" pb="10px" isInline alignItems="center">
          <Box as={IoIosArrowBack} size="16px" color="primary.500" />
          <Text color="primary.400" fontSize="xs">Messages</Text>
          <AvatarGroup mx="30px" size="sm" max={2}>
            <Avatar name="Tom" src="https://ca.slack-edge.com/T4JUEB3ME-UHVBU95RC-8b9c4a81bdcd-512" />
            <Avatar name="Pizza Yolo" />
          </AvatarGroup>                  
        </Stack>
        <Flex 
          flexDir="column"
          minH="530px"
        >
            <Stack my="4" flexGrow="1" justifyContent="space-between">
            <Box w="50%" minW="300px">
            {/* Phone chat section*/}
            <Stack m="10px" isInline alignItems="center" justifyContent="flex-start">
              <Box 
                color="primary.500"
                bg="success.100"
                p="10px" 
                w="85%"
                borderBottomRightRadius="20px"
                borderTopRightRadius="20px"
                borderTopLeftRadius="20px"
                >
                <Text fontSize="sm">
                  <span role="img" aria-label="Hello">
                    👋
                  </span>
                  Hi Tom your order for four pizzas with pineaple is ready to be picked up <br/>
                  <span role="img" aria-label="Pizza and pineaple">
                    🍕🍍
                  </span>
                </Text>
              </Box>
            </Stack>
            <Stack isInline justifyContent="flex-end">
              <Box 
                color="primary.500"
                p="10px" 
                m="5px" 
                bg="info.100"
                w="50%"
                borderBottomLeftRadius="20px"
                borderTopRightRadius="20px"
                borderTopLeftRadius="20px"
                >
                <Text fontSize="sm">
                  Ho, that's great!
                </Text>
              </Box>
            </Stack>
            <Stack m="10px" isInline alignItems="center" justifyContent="flex-start">
              <Box 
                color="primary.500"
                bg="success.100"
                p="10px" 
                w="85%"
                borderBottomRightRadius="20px"
                borderTopRightRadius="20px"
                borderTopLeftRadius="20px"
                >
                <Text fontSize="sm">
                  Save time by avoiding the queue. Pay your order here
                </Text>
              </Box>
            </Stack>
            <Stack m="10px" isInline alignItems="center" justifyContent="flex-start">
              <Box 
                color="primary.500"
                bg="success.100"
                py="10px" 
                w="90%"
                borderBottomRightRadius="20px"
                borderTopRightRadius="20px"
                borderTopLeftRadius="20px"
                >
                  <Stack isInline>
                    <Box borderRightWidth="1px" borderRightColor="primary.400">
                      <Logo width="60px" />
                    </Box>
                    <Text fontSize="xs">
                    Payment to Pizza Yolo 20$
                    <Box as="span" color="success.700">
                      {" "}
                      <br/>
                      https://dotpay.io/
                    </Box> 
                    </Text>
                  </Stack>
              </Box>
            </Stack>
            <Stack isInline justifyContent="flex-end">
              <Box 
                color="primary.500"
                p="10px" 
                m="5px" 
                bg="info.100"
                w="50%"
                borderBottomLeftRadius="20px"
                borderTopRightRadius="20px"
                borderTopLeftRadius="20px"
                >
                <Text fontSize="sm">
                  Wonderful !<span role="img" aria-label="Party"> 🥳</span>
                </Text>
              </Box>
            </Stack>
          </Box>
            
            {/* Phone Bottom section*/}
            <Stack alignItems="center" mx="10px" isInline>
              <Box as={FaRegImage} size="20px" color="primary.400" />
              <Box as={MdInsertEmoticon} size="20px" color="primary.400" />
              <InputGroup>
                <InputRightElement children={<Box border="1px" borderColor="success.100" borderRadius="50%" p="3px" size="28px" as={IoIosSend} color="success.400" />} />
                <Input borderRadius="30px" borderWidth="1px" borderColor="primary.200" size="sm" isDisabled={true} />
              </InputGroup>                      
            </Stack>

            </Stack>
          <Box>
            
          </Box>
        </Flex>
        </Box>
  );
}

export default PhoneMockup;